var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderDeco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 25,
    viewBox: "0 0 38 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9094 12.4547L18.8321 18.532C15.411 21.9531 9.81461 22.1514 6.33263 18.7858C2.75069 15.3203 2.75327 9.58638 6.33243 6.12385C8.4608 4.06212 11.4727 3.35777 14.257 3.93061C15.9508 4.27768 17.5578 5.10317 18.8324 6.37772L24.9094 12.4547Z",
    fill: "#FF3CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4548 12.4547L25.3775 18.532C21.9564 21.9531 16.36 22.1514 12.878 18.7858C9.2961 15.3203 9.29868 9.58638 12.8778 6.12385C15.0062 4.06212 18.0181 3.35777 20.8024 3.93061C22.4963 4.27768 24.1032 5.10317 25.3778 6.37772L31.4548 12.4547Z",
    fill: "#32A0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9997 12.4547L31.9224 18.532C28.5013 21.9531 22.9049 22.1514 19.423 18.7858C15.841 15.3203 15.8436 9.58638 19.4228 6.12385C21.5511 4.06212 24.563 3.35777 27.3473 3.93061C29.0412 4.27768 30.6482 5.10317 31.9227 6.37772L37.9997 12.4547Z",
    fill: "#FFC832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderDeco);
export default __webpack_public_path__ + "static/media/headerDeco.1cb5e526cf0b28873b7d1bbe1fa79df1.svg";
export { ForwardRef as ReactComponent };